import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesNoAccessMain } from './modules/ui/Main';

const NoAccessPage = (
  <SuspensePage>
    <PagesNoAccessMain />
  </SuspensePage>
);

export default NoAccessPage;
